import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Constructionbusiness() {
  return (
    <section className="construction_business p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>
              Get a <span>Custom Software Solution</span> to Optimize,
              Streamline, and <span>Scale Your Construction</span> Business
              Company
            </h2>
            <p>
              Develop impactful software solutions and unlock the full potential
              of your construction projects with Tekrevol’s proven expertise and
              agile-driven delivery process.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="construction-buss-main">
              <div className="const-buss-item">
                <div className="const-list">
                  <ul>
                    <li>Real-Time Project Tracking</li>
                    <li>Automated Resource Allocation</li>
                    <li>Centralized Communication Hub</li>
                    <li>Customizable Dashboards</li>
                  </ul>
                </div>
              </div>
              <div className="const-buss-item">
                <div className="const-buss-img">
                  <StaticImage
                    src="../../images/services-usa/construction-software/const-buss-1.webp"
                    alt="Custom Software Solution"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={733}
                    height={428}
                  />
                </div>
              </div>
              <div className="const-buss-item">
                <div className="const-list">
                  <ul>
                    <li>Advanced Document Management</li>
                    <li>Budget Management and Forecasting</li>
                    <li>Data Analytics and Reporting Tools</li>
                    <li>Scalable Architecture</li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Constructionbusiness;
